// extracted by mini-css-extract-plugin
export default {"root":"_2r69x","content-wrapper":"_3-65h","contentWrapper":"_3-65h"};